import constants from 'constants/index'

const defineMarkers = (markers = []) => {
  const { COUNTRY_COORDS } = constants.leaflet

  return markers
    ?.map((item) => ({
      city: item.country,
      coords: COUNTRY_COORDS[item.country],
      quantity: item.quantity,
    }))
    .filter((marker) => marker.coords)
}

export default defineMarkers
